export default __webpack_public_path__ + "static/media/wa.24212788.svg";